module.exports = __webpack_public_path__ + "img/orange_055.65bf5fb6.png";